import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Message = ({ content, color, style, testId }) => (
  <div
    data-testid={testId}
    className={classNames('jisr-message', color && `jisr-message--${color}`)}
    style={style}
  >
    {content}
  </div>
)

Message.propTypes = {
  content: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  testId: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.shape(),
}
export default Message
